module.exports = __webpack_public_path__ + "static/img/logo_13899.ed5361a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/logo/logo_13899.jpg
// module id = 6rny
// module chunks = 167